/* Keep the quick-buy dialog and its resources out of the initial render path. */
(() => {
  const root = document.getElementById('gwa-qb');
  if (!root || window.__GwaQuickbuyLoaderReady) return;
  window.__GwaQuickbuyLoaderReady = true;

  let loading;
  let stylesheet;
  let activation = 0;

  function loadStyles() {
    if (stylesheet) return stylesheet;
    stylesheet = new Promise((resolve, reject) => {
      const link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = root.dataset.stylesheet;
      link.onload = resolve;
      link.onerror = () => {
        link.remove();
        stylesheet = undefined;
        reject(new Error('Quick-buy styles could not be loaded'));
      };
      document.head.append(link);
    });
    return stylesheet;
  }

  function load() {
    if (window.__GwaQuickbuyReady) return Promise.resolve();
    if (loading) return loading;
    // Do not open an unstyled dialog, even when its script is cached.
    loading = loadStyles().then(() => new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = root.dataset.script;
      script.async = true;
      script.onload = () => {
        if (window.__GwaQuickbuyReady) resolve();
        else {
          script.remove();
          reject(new Error('Quick-buy initialization failed'));
        }
      };
      script.onerror = () => {
        script.remove();
        reject(new Error('Quick-buy script could not be loaded'));
      };
      document.head.append(script);
    })).catch((error) => {
      loading = undefined;
      throw error;
    });
    return loading;
  }

  function triggerFor(event) {
    const target = event.target instanceof Element ? event.target : null;
    return target?.closest('[data-gwa-quickbuy]');
  }

  // Keyboard focus and pointer intent start loading before activation.
  function warm(event) {
    if (triggerFor(event)) load().catch(() => {});
  }
  document.addEventListener('pointerover', warm, { passive: true });
  document.addEventListener('pointerdown', warm, { passive: true });
  document.addEventListener('focusin', warm);

  document.addEventListener('click', async (event) => {
    const trigger = triggerFor(event);
    if (!trigger || window.__GwaQuickbuyReady) return;
    event.preventDefault();
    event.stopPropagation();
    const current = ++activation;
    trigger.setAttribute('aria-busy', 'true');
    try {
      await load();
      if (current === activation && trigger.isConnected) trigger.click();
    } catch (_) {
      // A failed optional dialog must not prevent reaching the product.
      if (current === activation && trigger.dataset.productUrl) {
        const url = new URL(trigger.dataset.productUrl, window.location.href);
        if (url.origin === window.location.origin) window.location.assign(url.href);
      }
    } finally {
      trigger.removeAttribute('aria-busy');
    }
  }, true);
})();
